module.exports = __webpack_public_path__ + "media/components/content_header/static/blogpic-2ac738be6ae7aa4ddde87e179829daa9.jpg";